import { FilterSection } from './FilterSection';
import { PropsWithChildren } from 'react';
import styles from './Table.module.css';
import { Loading } from './Loading';
import classNames from 'classnames';
import { Caption } from './Caption';
import { Context } from './Context';
import { Filter } from './Filter';
import { Search } from './Search';
import { Empty } from './Empty';
import { Head } from './Head';
import { Body } from './Body';
import { Col } from './Col';
import { Row } from './Row';
import { Bar } from './Bar';

type Props = PropsWithChildren & { bg?: 'even' | 'odd'; variant?: 'plain' };

// eslint-disable-next-line react-refresh/only-export-components
function TableElement({ children, bg, variant }: Props) {
  return (
    <div className={styles.table}>
      <table
        className={classNames({
          [styles.even]: bg === 'even',
          [styles.odd]: bg === 'odd',
          [styles.plain]: variant === 'plain',
        })}
      >
        {children}
      </table>
    </div>
  );
}

export const Table = Object.assign(TableElement, {
  FilterSection,
  Context,
  Loading,
  Caption,
  Search,
  Filter,
  Empty,
  Head,
  Body,
  Bar,
  Row,
  Col,
});
